import Form from "./sections/Form";

import styles from "./Contact.styles";
import Seo from "../../components/Seo";
import { useI18n } from "../../i18n";

export default function Contact({type = 'contact'}) {
  const { t } = useI18n();
  return (
    <div className={`${styles.container}`}>
      <Seo title={t("seo_contact_title")} description={t("seo_contact_desc")} />
      <Form type={type} />
    </div>
  );
}
